module.exports = __webpack_public_path__ + "static/media/clothes_title_zh.09f481d9.png";